import { ReactElement } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { Cameraswitch } from '@mui/icons-material'
import { ToggleButton } from '@ui/actions'
import { refusePaneChange, roofStoreyKey, useModelStore } from '@editorStores'

interface Props {
  isOrthographic: boolean
  setIsOrthographic: (ortho: boolean) => void
}

const OrthographicControls = ({ isOrthographic, setIsOrthographic }: Props): ReactElement => {
  const setStoreyVisibility = useModelStore(state => state.setStoreyVisibility)

  const handleClick = () => {
    // A form refusing to leave its pane refuses the 2D/3D switch, so leave the roof alone too
    if (refusePaneChange()) return

    // when going from 3D -> ortho, turn roof off
    // when going from ortho -> 3D, turn roof back on
    isOrthographic
      ? setStoreyVisibility(roofStoreyKey, true) // ortho -> 3D
      : setStoreyVisibility(roofStoreyKey, false) // 3D -> ortho
    // toggle state
    setIsOrthographic(!isOrthographic)
  }

  useHotkeys(
    ['o'],
    event => {
      if (event.key === 'o') {
        handleClick()
      }
    },
    { enabled: true },
    [isOrthographic],
  )

  return (
    <ToggleButton
      value="snap"
      size="small"
      onClick={handleClick}
      selected={isOrthographic}
      Icon={Cameraswitch}
      hint="2D / 3D umschalten"
      aria-label="2D / 3D umschalten"
      data-cy="btn-ortho-view"
    />
  )
}

export default OrthographicControls
